import React from 'react'
import { Users, Target, Award, Heart } from 'lucide-react'

const AboutPage = () => {
  const values = [
    {
      icon: Target,
      title: 'Our Mission',
      description: 'To empower businesses of all sizes with intelligent AI agents that deliver exceptional customer experiences while reducing operational costs.'
    },
    {
      icon: Users,
      title: 'Our Team',
      description: 'A diverse group of AI researchers, engineers, and customer success experts passionate about transforming business communication.'
    },
    {
      icon: Award,
      title: 'Our Expertise',
      description: 'Over 10 years of combined experience in AI, natural language processing, and enterprise software development.'
    },
    {
      icon: Heart,
      title: 'Our Values',
      description: 'Customer-first approach, continuous innovation, data privacy, and ethical AI development guide everything we do.'
    }
  ]

  return (
    <main data-component-path="client/src/pages/AboutPage.jsx" data-component-line="33:4" data-component-id="client/src/pages/AboutPage.jsx:33:4" className="pt-20 bg-gray-50 min-h-screen">
      <div data-component-path="client/src/pages/AboutPage.jsx" data-component-line="34:6" data-component-id="client/src/pages/AboutPage.jsx:34:6" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div data-component-path="client/src/pages/AboutPage.jsx" data-component-line="35:8" data-component-id="client/src/pages/AboutPage.jsx:35:8" className="text-center mb-16">
          <h1 data-component-path="client/src/pages/AboutPage.jsx" data-component-line="36:10" data-component-id="client/src/pages/AboutPage.jsx:36:10" className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            About HelplineAgent
          </h1>
          <p data-component-path="client/src/pages/AboutPage.jsx" data-component-line="39:10" data-component-id="client/src/pages/AboutPage.jsx:39:10" className="text-xl text-gray-600 max-w-3xl mx-auto">
            We're on a mission to revolutionize customer service with AI-powered chatbots and voice agents
          </p>
        </div>

        <div data-component-path="client/src/pages/AboutPage.jsx" data-component-line="44:8" data-component-id="client/src/pages/AboutPage.jsx:44:8" className="bg-white rounded-2xl shadow-lg p-8 md:p-12 mb-16">
          <h2 data-component-path="client/src/pages/AboutPage.jsx" data-component-line="45:10" data-component-id="client/src/pages/AboutPage.jsx:45:10" className="text-3xl font-bold text-gray-900 mb-6">Our Story</h2>
          <div data-component-path="client/src/pages/AboutPage.jsx" data-component-line="46:10" data-component-id="client/src/pages/AboutPage.jsx:46:10" className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-4">
            <p data-component-path="client/src/pages/AboutPage.jsx" data-component-line="47:12" data-component-id="client/src/pages/AboutPage.jsx:47:12">
              HelplineAgent was founded in 2020 by a team of AI researchers and customer service professionals who saw the potential for artificial intelligence to transform how businesses interact with their customers. We recognized that traditional customer support models were struggling to keep up with growing customer expectations for instant, personalized service.
            </p>
            <p data-component-path="client/src/pages/AboutPage.jsx" data-component-line="50:12" data-component-id="client/src/pages/AboutPage.jsx:50:12">
              Starting with a simple chatbot platform, we've evolved into a comprehensive AI agent solution that serves thousands of businesses worldwide. Our platform now handles millions of customer interactions daily, helping companies reduce costs while improving customer satisfaction.
            </p>
            <p data-component-path="client/src/pages/AboutPage.jsx" data-component-line="53:12" data-component-id="client/src/pages/AboutPage.jsx:53:12">
              Today, HelplineAgent is trusted by businesses across e-commerce, healthcare, finance, education, and professional services. We continue to innovate, adding new features and capabilities based on customer feedback and advances in AI technology.
            </p>
          </div>
        </div>

        <div data-component-path="client/src/pages/AboutPage.jsx" data-component-line="59:8" data-component-id="client/src/pages/AboutPage.jsx:59:8" className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {values.map((value, index) => {
            const Icon = value.icon
            return (
              <div data-component-path="client/src/pages/AboutPage.jsx" data-component-line="63:14" data-component-id="client/src/pages/AboutPage.jsx:63:14"
                key={index}
                className="bg-white rounded-xl shadow-md p-8 hover:shadow-lg transition-shadow"
              >
                <div data-component-path="client/src/pages/AboutPage.jsx" data-component-line="67:16" data-component-id="client/src/pages/AboutPage.jsx:67:16" className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
                  <Icon data-component-path="client/src/pages/AboutPage.jsx" data-component-line="68:18" data-component-id="client/src/pages/AboutPage.jsx:68:18" className="w-8 h-8 text-blue-600" />
                </div>
                <h3 data-component-path="client/src/pages/AboutPage.jsx" data-component-line="70:16" data-component-id="client/src/pages/AboutPage.jsx:70:16" className="text-2xl font-bold text-gray-900 mb-4">{value.title}</h3>
                <p data-component-path="client/src/pages/AboutPage.jsx" data-component-line="71:16" data-component-id="client/src/pages/AboutPage.jsx:71:16" className="text-gray-600 leading-relaxed">{value.description}</p>
              </div>
            )
          })}
        </div>

        <div data-component-path="client/src/pages/AboutPage.jsx" data-component-line="77:8" data-component-id="client/src/pages/AboutPage.jsx:77:8" className="bg-blue-600 rounded-2xl p-12 text-center text-white">
          <h2 data-component-path="client/src/pages/AboutPage.jsx" data-component-line="78:10" data-component-id="client/src/pages/AboutPage.jsx:78:10" className="text-3xl md:text-4xl font-bold mb-4">
            Join Thousands of Satisfied Customers
          </h2>
          <p data-component-path="client/src/pages/AboutPage.jsx" data-component-line="81:10" data-component-id="client/src/pages/AboutPage.jsx:81:10" className="text-xl mb-8 text-blue-100 max-w-2xl mx-auto">
            Start your free trial today and experience the power of AI-driven customer service
          </p>
          <a data-component-path="client/src/pages/AboutPage.jsx" data-component-line="84:10" data-component-id="client/src/pages/AboutPage.jsx:84:10"
            href="/signup"
            className="inline-flex h-14 px-8 bg-white text-blue-600 rounded-lg hover:bg-gray-100 items-center justify-center gap-2 transition-all duration-200 shadow-lg hover:shadow-xl font-semibold text-lg"
          >
            Get Started Free
          </a>
        </div>
      </div>
    </main>
  )
}

export default AboutPage